module.exports = __webpack_public_path__ + "img/wiseEstimateWatermark.cb1133df.png";